import { useMemo } from 'react';
import { List as ImmutableList } from 'immutable';
import { INamedEntity, INamedEntityImt } from 'common/interfaces/common';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import { selectCurrentUserAvailableClubs as selectClubs } from 'modules/authentication/state/selectors';
import { IFilterOption } from 'common/interfaces/filter';
import { getArray } from 'common/utils/typeUtils';
import useClubPermissionChecker from 'common/hooks/useClubPermissionChecker';
import useRootSelector from 'common/hooks/useRootSelector';

export default function useClubFilterOptions(permission: Permission): IFilterOption[] {
  const clubList: ImmutableList<INamedEntityImt> = useRootSelector(selectClubs);
  const clubs = getArray<INamedEntity>(clubList?.toJS());
  const hasClubPermission = useClubPermissionChecker();

  return useMemo((): IFilterOption[] => {
    const filterOptions: IFilterOption[] = [];

    for (const club of clubs) {
      if (hasClubPermission(club.id, permission)) {
        filterOptions.push({
          key: club.id,
          label: club.title,
          value: club.id,
        });
      }
    }

    return filterOptions;
  }, [clubs, hasClubPermission, permission]);
}
